module.exports = __webpack_public_path__ + "img/level-3.8cd58053.png";